import CafeBoxCalculator from "../../components/categories/CafeBoxCalculator";

const CafesGourmands = () => {
  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-12">
        Cafés Gourmands
      </h1>

      <CafeBoxCalculator />
    </div>
  );
};

export default CafesGourmands;
